export const availableRoles = {
  Marketing: "marketing",
  Ventas: "ventas",
};
